
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Im Schnitt schlafen die Menschen nach spätestens 30 Minuten ein. Wer nach dem Zubettgehen länger wach liegt, sollte subito das Bett verlassen. Dies, bevor das Gedankenkarussell sich zu drehen beginnt. Ob man dann ein paar Seiten in einem Buch liest, meditiert, den Nachthimmel beobachtet, einen Lavendel-Tee mit Honig trinkt, oder auch nur sein Haustier kuschelt, spielt keine Rolle. Hauptsache, man setzt sich selber nicht unter Druck. Darum ist es wichtig, nur dann ins Bett zu gehen, wenn man wirklich müde ist.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;